export default __webpack_public_path__ + "static/media/learner.61e34fa7.png";